export const SIGNALR_HUB = 'https://lip-socket-uat.betsolutions.net/inplayhub/';
export const BETAPI = 'https://uat3_betapi.betsolutions.net/';

export const MATCH_TIMERS = {
    "Tennis": 10,
    "Rugby": 10,
    "Cricket": 8,
    "Basketball": 12,
    "Soccer": 12,
    "Default": 8,
    "AmericanFootball": 13,
    "AussieRules": 10,
    "Baseball": 10,
    "Futsal": 5,
    "Difference": 4,
    "TableTennis": 15,
    "Hockey": 15,
    "BeachVolley": 10,
    "HandBall":10
}
export const SPORTS_AVAILABLE = {
    "Football": "Football",
    "Tennis": "Tennis"
}
export const STATSCORE_WIDGET = true;
export const STATSCORE_CONFIG_ID = '63c7c7ebecd1603eb251ad86';
export const IMGStreamingIP = '45.222.109.231';
export const DARK_MODE = false;